/* @ngInject */

function AssetPreviewTabsController ($rootScope, $scope, $translate, $timeout, TemplateService, AssetService, SegmentService, RepositoryService) {
  $scope.location = $scope.location || 'materials'
  $scope.previewFlags.tabHasNewComment = $scope.template?.unreadComments > 0 || $scope.contextData?.task?.unreadComments

  const api = {
    _loadTabs,
    _getEventNameByLocation,
    _normalizeData,
    _handlePreviewFlags
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._loadTabs(true)
  }

  $scope.$watchCollection('template', () => {
    const isTemplate = !$scope.template.isFolder && (!$scope.template.assetId || $scope.template.assetId !== $scope.template.id)
    const isFolder = $scope.template.isFolder
    const lastApprovalDate = $scope.template?.lastApprovalDate

    if (isTemplate) {
      TemplateService.getTemplateDetailsForPreview($scope.template.id)
        .then((details) => {
          $scope.details = details
          $scope.details.lastApprovalDate = lastApprovalDate
        })
    } else if (isFolder) {
      RepositoryService.getFolderById($scope.template.id).then(details => {
        $scope.details = api._normalizeData(details)
      })
    } else {
      AssetService.getAssetDetailsById($scope.template.id).then(details => {
        $scope.details = api._normalizeData(details)
      })
    }
  })

  $scope.$watchCollection('previewFlags.tabHasNewComment', () => {
    api._loadTabs(false)
    const eventName = api._getEventNameByLocation($scope.location)
    if (eventName) {
      $rootScope.$broadcast(eventName)
    }
  })

  function _normalizeData (details) {
    return {
      ...$scope.template,
      ...details
    }
  }

  function _getEventNameByLocation (location) {
    const screens = {
      materialsApproval: 'reload-approval-list'
    }

    if (screens[location]) return screens[location]
    return ''
  }

  $scope.changeTab = tabName => {
    if ($scope.previewFlags.showVersionControl) return

    $timeout(
      () => {
        if ($scope.previewFlags.currentTab === tabName && $scope.previewFlags.tabsIsOpen) {
          $scope.previewFlags.tabsIsOpen = false
          $scope.previewFlags.currentTab = ''
        } else {
          $scope.previewFlags.tabsIsOpen = true
          $scope.previewFlags.currentTab = tabName
        }

        api._handlePreviewFlags()
      },
      0,
      true
    )

    SegmentService.track('preview-tab-click', {
      place: $scope.location,
      asset_id: $scope.template.id,
      tab_name: tabName
    })
  }

  function _loadTabs (firstLoading) {
    $timeout(() => {
      $scope.allAssetTabs = [
        {
          name: 'comments',
          tooltip: $translate.instant('comments'),
          icon: 'message-square',
          locations: ['workflow', 'materialsApproval'],
          hasNotification: $scope.previewFlags.tabHasNewComment
        },
        {
          name: 'info',
          tooltip: $translate.instant('information'),
          icon: 'info',
          locations: ['workflow', 'materials', 'materialsCustomizations', 'materialsApproval', 'posts', 'brand', 'checklist', 'briefing', 'repository', 'repositoryFolder', 'campaign', 'campaignAttachment'],
          hasNotification: false
        },
        {
          name: 'categories',
          tooltip: $translate.instant('assetPreviewTags.title'),
          icon: 'tag',
          locations: ['materials', 'repository'],
          hasNotification: false
        },
        {
          name: 'instructions',
          tooltip: $translate.instant('usageInstructions'),
          icon: 'file-text',
          locations: ['materials'],
          hasNotification: false
        },
        {
          name: 'activities',
          tooltip: $translate.instant('activities'),
          icon: 'clock',
          locations: ['materials', 'materialsApproval', 'repository', 'repositoryFolder', 'workflow'],
          hasNotification: false
        },
        {
          name: 'usage',
          tooltip: $translate.instant('assetPreview.tabs.usage.title'),
          icon: 'dam',
          locations: ['repository'],
          hasNotification: false
        },
        {
          name: 'results',
          tooltip: $translate.instant('results'),
          icon: 'analytics',
          iconCategory: 'features',
          locations: ['materials'],
          hasNotification: false
        },
        {
          name: 'results-posts',
          tooltip: $translate.instant('results'),
          icon: 'analytics',
          iconCategory: 'features',
          locations: ['posts'],
          hasNotification: false
        }
      ]

      $scope.assetTabs = $scope.allAssetTabs.filter(tab => {
        if ($rootScope.isUserDesigner() && (tab.name === 'results' || tab.name === 'results-posts')) {
          return false
        }

        return tab.locations.find(location => location === $scope.location)
      })

      if (firstLoading && $scope.contextData?.openTab) {
        $scope.changeTab($scope.contextData.openTab)
      }
    }, 0, true)
  }

  function _handlePreviewFlags () {
    const { currentTab } = $scope.previewFlags

    if (currentTab !== 'comments') {
      $scope.previewFlags.isAddingAnnotation = false
    }
  }
}

export { AssetPreviewTabsController }
